<template>
  <WatchEmail />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
